import { ErrorBoundary, Main } from "@goodfill/ui-components";
import { FallbackUI } from "../FallbackUI";
import { useRecoilState } from "recoil";
import { isGlobalStateLoadingState } from "../../state";

export const PageLayoutFixed = ({ children }: { children: React.ReactNode }) => {
  const [isGlobalStateLoading] = useRecoilState(isGlobalStateLoadingState);

  return (
    <Main className={"items-center mt-14"}>
      <div style={{ maxWidth: "1240px", width: "100%" }}>
        {isGlobalStateLoading ? null : (
          <ErrorBoundary fallbackUI={<FallbackUI text="Error, could not render page" />}>{children}</ErrorBoundary>
        )}
      </div>
    </Main>
  );
};
